import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {DpStatsService} from '../dp-stats.service';
import {DemandPartnerRequest, DemandPartnerRequestType} from '../domain/demand-partner-request.model';
import {SnackBarService} from '../../shared/services/snackbar.service';
import {GlobalSpinnerService} from '../../shared/components/loader-service/global-spinner.service';
@Component({
  selector: 'cm-dp-reqiest-dialog',
  template: `
    <h4 mat-dialog-title>Comment</h4>
    <div mat-dialog-content class="">
      <div class="">
        <p class="mb-2">Site: <strong>{{request.siteName}}</strong></p>
        <p>Unit: <strong>{{request.bridgeAdUnitName}}</strong></p>
      </div>
	    <mat-divider></mat-divider>
	    <mat-form-field class="w-100 mt-3">
        <textarea matInput
                  (keyup.enter)="request.comment && submit()"
                  [(ngModel)]="request.comment" style="min-height: 150px "
                  placeholder="Enter comment here"></textarea>
      </mat-form-field>
    </div>
    <div mat-dialog-actions class="justify-content-center">
      <button mat-raised-button color="" class="mr-1" [mat-dialog-close]="false">Close</button>
	    <button mat-raised-button color="primary" [disabled]="!request.comment"
	            class="mr-1" (click)="request.comment && submit()">Submit
	    </button>
    </div>
  `,
})
export class DemandPartnerRequestDialogComponent {

  public request = new DemandPartnerRequest();

  constructor(public dialogRef: MatDialogRef<DemandPartnerRequestDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private dpStatsService: DpStatsService,
              private globalSpinnerService: GlobalSpinnerService,
              private snackBarService: SnackBarService) {
    this.request = Object.assign(new DemandPartnerRequest(), data, {
      type: DemandPartnerRequestType.COMMENT
    });
  }

  submit() {
    this.globalSpinnerService.showLoader();
    this.dpStatsService.adUnitRequest(this.request).subscribe(() => {
        this.snackBarService.success('Request submitted successfully');
        this.dialogRef.close(true);
        this.globalSpinnerService.hideLoader();
      },
      () => {
        this.globalSpinnerService.hideLoader();
        this.snackBarService.error('Error submitting request');
      });

  }
}
